import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
// import { DatePickerWithRange } from '../components/ui/date-range-picker';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const Relatorios: React.FC = () => {
  const [periodo, setPeriodo] = useState('hoje');
  const [activeTab, setActiveTab] = useState('geral');
  const [dateRange, setDateRange] = useState({ from: new Date(), to: new Date() });

  // Dados de exemplo para os gráficos
  const dadosAtendimentos = [
    { nome: 'Segunda', abertos: 12, fechados: 10, transferidos: 2 },
    { nome: 'Terça', abertos: 19, fechados: 15, transferidos: 3 },
    { nome: 'Quarta', abertos: 15, fechados: 12, transferidos: 1 },
    { nome: 'Quinta', abertos: 22, fechados: 18, transferidos: 4 },
    { nome: 'Sexta', abertos: 28, fechados: 24, transferidos: 3 },
    { nome: 'Sábado', abertos: 10, fechados: 8, transferidos: 1 },
    { nome: 'Domingo', abertos: 5, fechados: 4, transferidos: 0 },
  ];

  const dadosTempoResposta = [
    { nome: 'Segunda', tempo: 5 },
    { nome: 'Terça', tempo: 8 },
    { nome: 'Quarta', tempo: 4 },
    { nome: 'Quinta', tempo: 6 },
    { nome: 'Sexta', tempo: 9 },
    { nome: 'Sábado', tempo: 3 },
    { nome: 'Domingo', tempo: 2 },
  ];

  const dadosSatisfacao = [
    { nome: 'Muito Satisfeito', valor: 65 },
    { nome: 'Satisfeito', valor: 25 },
    { nome: 'Neutro', valor: 5 },
    { nome: 'Insatisfeito', valor: 3 },
    { nome: 'Muito Insatisfeito', valor: 2 },
  ];

  const dadosAtendentes = [
    { nome: 'Ana', atendimentos: 45, satisfacao: 4.8 },
    { nome: 'Carlos', atendimentos: 38, satisfacao: 4.5 },
    { nome: 'Beatriz', atendimentos: 52, satisfacao: 4.7 },
    { nome: 'Daniel', atendimentos: 30, satisfacao: 4.2 },
    { nome: 'Eduarda', atendimentos: 41, satisfacao: 4.6 },
  ];

  const CORES_SATISFACAO = ['#4CAF50', '#8BC34A', '#FFC107', '#FF9800', '#F44336'];

  // Estatísticas resumidas
  const estatisticas = {
    totalAtendimentos: 156,
    atendimentosAbertos: 28,
    atendimentosFechados: 128,
    tempoMedioResposta: '5.3 min',
    tempoMedioResolucao: '2.4 horas',
    satisfacaoMedia: '4.5/5',
  };

  // Atualizar dados com base no período selecionado
  useEffect(() => {
    // Em um sistema real, aqui faria uma chamada à API para buscar os dados do período selecionado
    console.log(`Buscando dados para o período: ${periodo}`);
    // Para este exemplo, estamos usando dados estáticos
  }, [periodo, dateRange]);

  return (
    <div className="container mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <div className="flex items-center space-x-4">
          <Select value={periodo} onValueChange={setPeriodo}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Selecione o período" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="hoje">Hoje</SelectItem>
              <SelectItem value="ontem">Ontem</SelectItem>
              <SelectItem value="7dias">Últimos 7 dias</SelectItem>
              <SelectItem value="30dias">Últimos 30 dias</SelectItem>
              <SelectItem value="personalizado">Personalizado</SelectItem>
            </SelectContent>
          </Select>
          
          {/* {periodo === 'personalizado' && (
            <DatePickerWithRange 
              date={dateRange} 
              setDate={setDateRange} 
            />
          )} */}
          
          <Button className="bg-green-600 hover:bg-green-700">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Exportar
          </Button>
        </div>
      </div>

      {/* Cards de estatísticas */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-500">Total de Atendimentos</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{estatisticas.totalAtendimentos}</div>
            <p className="text-xs text-gray-500">+12% em relação ao período anterior</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-500">Tempo Médio de Resposta</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{estatisticas.tempoMedioResposta}</div>
            <p className="text-xs text-gray-500">-8% em relação ao período anterior</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-gray-500">Satisfação do Cliente</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{estatisticas.satisfacaoMedia}</div>
            <p className="text-xs text-gray-500">+0.2 em relação ao período anterior</p>
          </CardContent>
        </Card>
      </div>

      {/* Tabs para diferentes visualizações */}
      <Tabs defaultValue="geral" value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="geral">Visão Geral</TabsTrigger>
          <TabsTrigger value="atendentes">Atendentes</TabsTrigger>
          <TabsTrigger value="satisfacao">Satisfação</TabsTrigger>
          <TabsTrigger value="canais">Canais</TabsTrigger>
        </TabsList>

        {/* Tab: Visão Geral */}
        <TabsContent value="geral" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Volume de Atendimentos</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={dadosAtendimentos}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="nome" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="abertos" name="Abertos" fill="#4CAF50" />
                    <Bar dataKey="fechados" name="Fechados" fill="#2196F3" />
                    <Bar dataKey="transferidos" name="Transferidos" fill="#FF9800" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Tempo Médio de Resposta (minutos)</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={dadosTempoResposta}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="nome" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="tempo" name="Tempo (min)" fill="#3F51B5" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab: Atendentes */}
        <TabsContent value="atendentes" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Desempenho dos Atendentes</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={dadosAtendentes}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="nome" />
                    <YAxis yAxisId="left" orientation="left" stroke="#8884d8" />
                    <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" />
                    <Tooltip />
                    <Legend />
                    <Bar yAxisId="left" dataKey="atendimentos" name="Atendimentos" fill="#8884d8" />
                    <Bar yAxisId="right" dataKey="satisfacao" name="Satisfação (0-5)" fill="#82ca9d" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {dadosAtendentes.map((atendente, index) => (
              <Card key={index}>
                <CardHeader className="pb-2">
                  <CardTitle className="text-lg">{atendente.nome}</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-sm text-gray-500">Atendimentos</p>
                      <p className="text-xl font-semibold">{atendente.atendimentos}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Satisfação</p>
                      <p className="text-xl font-semibold">{atendente.satisfacao}/5</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Tempo Médio</p>
                      <p className="text-xl font-semibold">{Math.floor(Math.random() * 10) + 2} min</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </TabsContent>

        {/* Tab: Satisfação */}
        <TabsContent value="satisfacao" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Distribuição de Satisfação</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={dadosSatisfacao}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="valor"
                    >
                      {dadosSatisfacao.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={CORES_SATISFACAO[index % CORES_SATISFACAO.length]} />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Comentários Recentes</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div className="p-3 bg-green-50 border border-green-100 rounded-lg">
                  <div className="flex items-center mb-1">
                    <div className="flex items-center text-yellow-500">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <svg key={star} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      ))}
                    </div>
                    <span className="ml-2 text-sm font-medium">Maria S. - Hoje</span>
                  </div>
                  <p className="text-sm">Atendimento excelente e muito rápido. O atendente Carlos foi muito prestativo e resolveu meu problema em minutos!</p>
                </div>

                <div className="p-3 bg-green-50 border border-green-100 rounded-lg">
                  <div className="flex items-center mb-1">
                    <div className="flex items-center text-yellow-500">
                      {[1, 2, 3, 4].map((star) => (
                        <svg key={star} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      ))}
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                    </div>
                    <span className="ml-2 text-sm font-medium">João P. - Ontem</span>
                  </div>
                  <p className="text-sm">Bom atendimento, mas demorou um pouco para resolver minha questão. No final, tudo foi resolvido satisfatoriamente.</p>
                </div>

                <div className="p-3 bg-red-50 border border-red-100 rounded-lg">
                  <div className="flex items-center mb-1">
                    <div className="flex items-center text-yellow-500">
                      {[1, 2].map((star) => (
                        <svg key={star} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      ))}
                      {[1, 2, 3].map((star) => (
                        <svg key={star} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      ))}
                    </div>
                    <span className="ml-2 text-sm font-medium">Ana R. - 2 dias atrás</span>
                  </div>
                  <p className="text-sm">Demorou muito para responder e tive que repetir várias vezes a mesma informação. Precisa melhorar o treinamento dos atendentes.</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab: Canais */}
        <TabsContent value="canais" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Distribuição por Canais</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={[
                        { name: 'WhatsApp', valor: 65 },
                        { name: 'Instagram', valor: 15 },
                        { name: 'Facebook', valor: 10 },
                        { name: 'Site', valor: 8 },
                        { name: 'Outros', valor: 2 },
                      ]}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="valor"
                    >
                      <Cell fill="#25D366" /> {/* Sinticket */}
                      <Cell fill="#E1306C" /> {/* Instagram */}
                      <Cell fill="#4267B2" /> {/* Facebook */}
                      <Cell fill="#2196F3" /> {/* Site */}
                      <Cell fill="#9E9E9E" /> {/* Outros */}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-500">Sinticket</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">65%</div>
                <p className="text-xs text-gray-500">101 atendimentos</p>
              </CardContent>
            </Card>
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-500">Instagram</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">15%</div>
                <p className="text-xs text-gray-500">23 atendimentos</p>
              </CardContent>
            </Card>
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-500">Facebook</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">10%</div>
                <p className="text-xs text-gray-500">16 atendimentos</p>
              </CardContent>
            </Card>
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-500">Site</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">8%</div>
                <p className="text-xs text-gray-500">12 atendimentos</p>
              </CardContent>
            </Card>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Relatorios;
